import { useContext } from "react";
import useOsPoiService from "../../../../hooks/useOsPoiService";
import ImportTable from "../ImportTable/ImportTable"
import TriggerImport from "./ImportActions"
import { LayerContext } from "../LayerContext";

const OsPoiLayer = () => {

    const osPoiService = useOsPoiService();
    const layerContext = useContext(LayerContext);

    return <>
        <TriggerImport service={osPoiService} onSubmitted={() => { layerContext?.refreshLayerInfo() }} />
        <ImportTable />
    </>
}

export default OsPoiLayer